import Layout from 'antd/lib/layout';
import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { replaceURLDomainToBrowserDomain } from 'api/base/helpers';
import NotFound from 'pages/apps/_shared/NotFound';
import Maintenance from 'pages/apps/_shared/Maintenance';
import SurveyRouteConfig from 'pages/apps/survey/SurveyRouteConfig';
import { ALL_PATHS } from 'shared/routes/constants';

import styles from './app.module.scss';

const MAINTENANCE_FETCH_TIMEOUT_MS = 2000;
const MAINTENANCE_ENDPOINT = `${replaceURLDomainToBrowserDomain(
  process.env.REACT_APP_API_ENDPOINT as string,
)}/config/maintenance`;

const URLDecodeRedirect = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    try {
      const decoded = decodeURI(location.pathname);
      if (decoded !== location.pathname) {
        history.replace(decoded + location.search + location.hash);
      }
    } catch {
      console.warn('Failed to decode URL, redirecting to not found');
    }
  }, [location.pathname, history]);

  return null;
};

const App = () => {
  const [isMaintenanceEnabled, setIsMaintenanceEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), MAINTENANCE_FETCH_TIMEOUT_MS);

    fetch(MAINTENANCE_ENDPOINT, { signal: controller.signal })
      .then((response) => (response.ok ? response.json() : { maintenance: false }))
      .then((data) => setIsMaintenanceEnabled(data?.maintenance === true))
      .catch(() => setIsMaintenanceEnabled(false))
      .finally(() => clearTimeout(timeoutId));

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, []);

  if (isMaintenanceEnabled === null) {
    return null;
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Survey</title>
      </Helmet>
      <URLDecodeRedirect />
      <Layout className={styles.container}>
        <Switch>
          <Route
            exact
            path={ALL_PATHS}
            component={isMaintenanceEnabled ? Maintenance : SurveyRouteConfig}
          />
          <Route path="*" component={NotFound} />
        </Switch>
      </Layout>
    </>
  );
};

export default App;
